// extracted by mini-css-extract-plugin
module.exports = {"heroImg":"GKNQvLo1q+R7CiCivg-k3w=="};